import { ReactElement } from 'react';
import { Outlet } from 'react-router-dom';

const SettingWrapper = (): ReactElement => <Outlet />;

export default SettingWrapper;
